import React from 'react';
import { useNavigate } from 'react-router-dom';
import HeroBanner from '../components/home/HeroBanner';
import { ContentRow } from '../components/ui/MovieCard';
import { HomeSkeleton } from '../components/ui/Skeleton';
import SmartImage from '../components/ui/SmartImage';
import { useHomeData, useWatchlist, useGeneralMessage, useContinueWatching } from '../hooks/useApi';
import { useAuth } from '../context/AuthContext';

function ContinueCard({ item, onClick }) {
  const pct = item.duration > 0 ? Math.min(100, Math.round((item.position / item.duration) * 100)) : 0;
  return (
    <div className="cw-card" onClick={onClick}>
      <div className="cw-thumb">
        <SmartImage movie={item} type="landscape" alt={item.title} className="cw-img" />
        <div className="cw-play-overlay">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="white"><polygon points="5 3 19 12 5 21 5 3"/></svg>
        </div>
        <div className="cw-progress-bar">
          <div className="cw-progress-fill" style={{ width: `${pct}%` }} />
        </div>
      </div>
      <p className="cw-title">{item.title}</p>
      {item.episodetitle && <p className="cw-ep">{item.episodetitle}</p>}
    </div>
  );
}

export default function HomePage() {
  const { banners, categories, loading, error, refetch } = useHomeData();
  const { toggleWatchlist }    = useWatchlist();
  const { data: announcement } = useGeneralMessage();
  const { items: cwItems }     = useContinueWatching();
  const { isAuthenticated }    = useAuth();
  const navigate = useNavigate();

  if (loading) return <HomeSkeleton />;

  if (error) {
    return (
      <div className="error-view">
        <div className="error-icon">⚠</div>
        <p>Couldn't load content. Check your connection.</p>
        <button className="btn-primary" onClick={refetch}>Retry</button>
      </div>
    );
  }

  return (
    <div className="home-page">
      {announcement?.message && (
        <div className="announcement-bar">
          <span>📢 {announcement.message}</span>
        </div>
      )}

      <HeroBanner movies={banners.slice(0, 5)} />

      <div className="content-sections">
        {isAuthenticated && cwItems.length > 0 && (
          <section className="cw-section">
            <h2 className="row-title">Continue Watching</h2>
            <div className="cw-row">
              {cwItems.map(item => (
                <ContinueCard
                  key={item.filmid || item.id}
                  item={item}
                  onClick={() => {
                    const vid = item.episodeid || item.vid || 'main';
                    navigate(`/watch/${item.filmid || item.id}/${vid}`);
                  }}
                />
              ))}
            </div>
          </section>
        )}

        {categories.map((row) => (
          <ContentRow
            key={`${row.genre}-${row.displayOrder}`}
            title={row.genre}
            movies={row.movies ?? row.movieList ?? []}
            orientation={row.genretnorientation || 'V'}
            onWatchlistToggle={toggleWatchlist}
          />
        ))}
      </div>
    </div>
  );
}
